import { Button } from "@mui/material";
import styled from "styled-components";

const AddButton = styled(Button)`
  padding: 0;
`;

export default AddButton;
